
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#323334","d":"M15.9 1.56V.43a.42.42 0 00-.43-.42H.46a.42.42 0 00-.42.42v1.13c0 .23.19.42.42.42h15.01c.23 0 .42-.19.42-.42zM8.61 6.5H.38C.17 6.5 0 6.31 0 6.08V4.95c0-.24.17-.43.38-.43h8.24c.21 0 .38.2.38.43v1.13c0 .23-.17.42-.38.42zm6.81 9.03h-15a.42.42 0 01-.43-.42v-1.13c0-.23.19-.42.42-.42h15.01c.24 0 .43.19.43.42v1.13c0 .23-.2.42-.43.42zm-6.8-4.51H.37c-.2 0-.37-.2-.37-.43V9.46c0-.23.17-.42.38-.42h8.24c.21 0 .38.19.38.42v1.13c0 .24-.17.43-.38.43zM15 4.52h-4a1 1 0 00-1 1v4.5a1 1 0 001 1h4a1 1 0 001-1v-4.5a1 1 0 00-1-1z"}})])
          )
        }
      }
    